import { LitElement, html, css, nothing} from 'lit';
import {property, customElement, state} from 'lit/decorators.js';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import '@maersk-global/mds-components-core/mc-icon'
import '../../voyage-tooltip/src/voyage-tooltip';
import { UiStateModel } from '../../../src/models/ui-state-model';
import { ForecastInfo, WeatherModel } from '../../../src/models/weather-model';
import './voy-theme-menu';
import './polar-route-selection';
import './cloud-features/map-download-popup';
import './cloud-features/insight-hub/insight-hub-button';
import './cloud-features/activity-log/activity-log';
import { AlertType, VesselAlertsModel } from '../../../src/models/vessel-alerts-model';
import { getFormattedDateUTC, prettyTimelapsed, slowNetworkDetected, isOnline, UUID } from '../../../src/utils/helpers';
import { VesselPositionModel } from '../../../src/models/vessel-position-model';
import { CoordinatesUtils } from '../../../src/utils/coordinates-utils';
import '../../voyage-tooltip/src/voyage-tooltip-proxy';
import "@maersk-global/mds-components-core";
import '../../voy-panel/src/voy-panel'
import { MigrationChangeEvents, MigrationState, VesselMigrationModel } from '../../../src/models/vessel-migration-model';
import { voyageTopbarStylesCloud } from '../styles/voyage-topbar-styles-cloud';
import { Coordinate } from 'ol/coordinate';
import { AuthService } from '../../../src/services/auth/auth-service';
import { VoyageImoModel } from '../../../src/models/voyage-imo-model';
import { VoyageImoEventNames } from '../../../src/models/voyage-imo-model-impl';
import '../../nested-accordion/src/nested-accordion';
import { AccordionItemData } from '../../nested-accordion/src/accordion-item';
import { StyleName, VoyageStyle } from '../../voyage-style/src/voyage-style';
import { DownloadState, cloudMapsOffline } from '../../../src/maplayers/cloud-maps-offline';
import { getInsightStorageKey, InsightHubConfig, shouldShowInsightSurvey } from './cloud-features/insight-hub/insight-hub-utils';
import { clearSiteData } from '../../../src/utils/offline-utils';
import { ISTRINITYENABLED } from '../../../src/models/feature-flag-model-impl';

enum ForecastStatusColors {
    Green = "green",
    Yellow = "yellow",
    Red = "red"
  }

  interface PositionInfo {
    lat: string; 
    lon: string; 
    timestamp: string; 
    source?: string;

  }

  const isK8s = (<any>window)["appenv"].isK8s;
  const { 
    featureToggles: { offlineMapDownload = false, encTileServer = false },
    vesselOnCloud: isVesselOnCloud = false,
    insightsHubNPSKey,
    insightsHubSUSKey,
    insightsHubStartDate_NPS,
    insightsHubStartDate_SUS
} = (<any>window)["appenv"];


  export enum VoyageTopbarEventNames {
    ClosePolarRouteSelection = "close-polar-route-selection",
    ShowFeedbackForm = "show-feedback-form",
    ShowPolarRouteSelection = "show-polar-route-selection",
    ShowWeatherLimits = "show-weather-limits",
    ShowDepthsControl = "show-depths-control",
    ShowVesselCharacteristics = "show-vessel-characteristics",
    ShowVesselPosition = "show-vessel-position",
    ShowAlarmLogs = "show-alarm-logs",
    ShowPolarChart = "show-polar-chart",
    ShowHelpCenter = "show-help-center",
    ShowAudioAlert = "show-audio-alert",
  }


//to be renamed to voyage-topbar when this version is to be on edge as well
@customElement('voyage-topbar-cloud')
export class VoyageTopbarCloud extends LitElement {
    @property({type: String}) datestr: string = "";
    @property({type: Array}) polarRouteCapturedPosition: Coordinate|null = null;
    @property({type: Boolean}) showPolarTopBar: boolean = false;
    @property({type: Boolean}) showApplicationLinksDropdown: boolean = false;
    @property({type: Boolean}) showSettingsLinksDropdown: boolean = false;
    @property({type: Boolean}) showUserAccount: boolean = false;
    @property({type: Boolean}) showReleaseNotes: boolean = false;
    @property({type: String}) performanceLink: string = "";
    @property({type: String, attribute:'app-name'}) appName: string = "";
    @property({type: Object}) forecastInfo: ForecastInfo|null = WeatherModel!.latestForecastInfo;
    @property({ type: Boolean, attribute: 'show-forecast-info' }) showForecastInfo: boolean = false;
    @property({ type: Boolean, attribute: 'include-vessel-settings' }) includeVesselSettings: boolean = false;
    @property({ type: Boolean, attribute: 'demo-mode' }) demoMode: boolean = false;
    @property({ type: Boolean, attribute: 'demo-mode' }) _positionInfo: PositionInfo | null = null;
    @property({type: Boolean}) showImoError: boolean = false;
    @property({ type: Boolean }) hasParametricRisk: boolean = false
    @property({ type: Boolean }) hasActivePlan: boolean = false
    @property({ type: Boolean }) TrinityOn: boolean = false;

    // download map properties
    @property({ type: Boolean, attribute: false }) private _isDownloading: boolean = false;
    @property({ type: Number, attribute: false }) private _downloadProgress: number = 0;

    private _cloudMapLayer = new cloudMapsOffline();

    @state()
    private isOnline = isOnline();
    

    constructor() {
        super();

        this._updateWeatherForecastAlert = this._updateWeatherForecastAlert.bind(this);
        this._updateLastPosition = this._updateLastPosition.bind(this);
        this._onMigrateClicked = this._onMigrateClicked.bind(this);
        this._setMigrationState = this._setMigrationState.bind(this);

        this.TrinityOn = localStorage.getItem(ISTRINITYENABLED) === 'true';

        const updateDateStr = () => {
            const now = new Date();
            const month = now.toLocaleString('en-us', { month: 'short', timeZone: 'UTC' });
            const timePart = `${
                now.getUTCHours().toString().padStart(2,'0')}:${
                now.getUTCMinutes().toString().padStart(2,'0')}:${
                now.getUTCSeconds().toString().padStart(2,'0')}`;

            const datePart = `${month} ${
                now.getUTCDate().toString().padStart(2,'0')
            }`;

            this.datestr = `Time: ${timePart} / ${datePart} (UTC)`;
        }

        setInterval(() => {updateDateStr()}, 1000);
        updateDateStr();

        // restrict heartbeat to vessel users only, unless testing in dev environment
        const shouldSendHeartbeat = (<any>window)["appenv"].rumConfig.environment === "dev" ? true : sessionStorage.getItem('isVesselUser') === 'Yes';
        
        if (shouldSendHeartbeat) {
            setInterval(() => { VoyageImoModel?.sendHeartBeat() }, 5 * 60 * 1000); // every 5 minutes
            VoyageImoModel?.sendHeartBeat();
        }
    }

    //to be renamed to voyageTopbarStyles when this version is to be on edge as well
    static styles = voyageTopbarStylesCloud

    private insightHubNpsConfig = shouldShowInsightSurvey(
            localStorage.getItem(getInsightStorageKey('nps')),
            insightsHubStartDate_NPS,
            1
        ) ? {
            type: 'nps',
            key: insightsHubNPSKey,
            storageKey: getInsightStorageKey('nps'),
            startDate: insightsHubStartDate_NPS,
            monthsInterval: 1
        } : null;
    
    private insightHubSusConfig = shouldShowInsightSurvey(
        localStorage.getItem(getInsightStorageKey('sus')),
        insightsHubStartDate_SUS,
        6
        ) ? {
            type: 'sus',
            key: insightsHubSUSKey,
            storageKey: getInsightStorageKey('sus'),
            startDate: insightsHubStartDate_SUS,
            monthsInterval: 6
        } : null;
    
    render() {
        const insightsHubNps = (isOnline() && sessionStorage.getItem('isVesselUser') === 'Yes') ? this.insightHubNpsConfig : null;
        const insightsHubSus = (isOnline() && sessionStorage.getItem('isVesselUser') === 'Yes') ? this.insightHubSusConfig : null;

        const lastSyncedTime = localStorage.getItem('lastSyncedTime');
        return html`
        <div class="voyage-topbar-wrapper">
            <div class="voyage-topbar ${this.showPolarTopBar ? '' : "voyage-topbar--box-shadow"}">
                <!-- Logo section -->
                <div class="logo">
                    <span class="name">StarConnect</span>
                    <div class="logo-divider"></div>
                    <span class="label app-name">${this.appName}</span>
                    ${isVesselOnCloud ? html`<span class="logo-icon">${SvgIcons.customCloudLogo}</span>`: null}
                    <span class="version">${(<any>window)["appenv"].appVersion}</span>

                    ${isK8s && this._migrationState !== MigrationState.MigrationServiceNotFound && this._migrationState !== MigrationState.LocalDev ? html`
                        <div>
                            <mc-button
                                class="migrate-button"
                                label="Migrate"
                                variant="outlined"
                                fit="small"
                                @click=${this._onMigrateClicked}
                            >
                            </mc-button>
                            ${this._showMigrationPanel ?
                                html`
                                    <voy-panel class="migration-panel" panelTitle="Migrate">
                                        ${this._migrationElement()}
                                    </voy-panel>
                                `: nothing
                            }
                        </div>` : nothing
                    }
                </div>

                <!-- Status info section -->
                <div class="status-info">
                    <span>${this.datestr}</span>
                    ${this.showForecastInfo ? html`
                        <div class="divider"></div>
                        <div>
                            <span>Position: ${this._positionInfo?.timestamp}</span>
                            <voyage-tooltip-proxy
                                text=${`Last position update <br> ${
                                          this._positionInfo?.lat
                                      } <br> ${this._positionInfo?.lon}${
                                          isVesselOnCloud &&
                                          this._positionInfo?.source &&
                                          this._positionInfo.source !== ''
                                              ? `<br>(source: ${this._positionInfo.source})`
                                              : ''
                                      }`}
                                html-content
                                .tooltipInteraction=${true}
                                >
                            </voyage-tooltip-proxy>
                        </div>
                        <div class="divider"></div>
                        <div class="forecast" status=${this._forecastStatus}> Weather:
                                ${this._getForecastVersionText()}
                        </div>
                        `: html`` }
                </div>

                <!-- Toolbar (with user settings) section -->
                <div class="toolbar">
                    ${isVesselOnCloud ? html`<div class="connectivity">
                                ${(() => {
                                    const online = isOnline();
                                    const slowNetwork = online && slowNetworkDetected();
                                    return html`
                                        <div>
                                            ${online ? (slowNetwork ? html`<span class="network-status-icon slow-network"> ${SvgIcons.customCloudOnline}</span>`
                                            : html`<span class="network-status-icon online">${SvgIcons.customCloudOnline}</span>`) 
                                                : html`<span class="network-status-icon offline"> ${SvgIcons.customCloudOffline}</span>` }
                                            <voyage-tooltip-proxy
                                                text=${online ? (slowNetwork ? 'Experiencing slow network issue' : 'Connection status is online') : 'Connection status is offline'}
                                                html-content
                                                .positionPriority=${["bottom"]}
                                                .tooltipInteraction=${true}
                                            >
                                            </voyage-tooltip-proxy>
                                        </div>
                                    `;
                                })()}
                            <span>Last synced: ${getFormattedDateUTC(lastSyncedTime ? new Date(lastSyncedTime) : new Date())}</span>
                        </div>` : html``}
                    <activity-log-cloud></activity-log-cloud>
                    ${insightsHubNps ? html`<insight-hub-button popup-id=${insightsHubNps.key} storage-key=${insightsHubNps.storageKey} 
                         months-interval=${insightsHubNps.monthsInterval} start-date=${insightsHubNps.startDate} >
                        <span class="settings">${SvgIcons.feedbackIcon}</span>
                    </insight-hub-button>`: null}
                    ${insightsHubSus ? html`<insight-hub-button popup-id=${insightsHubSus.key} storage-key=${insightsHubSus.storageKey} 
                         months-interval=${insightsHubSus.monthsInterval} start-date=${insightsHubSus.startDate} > 
                    </insight-hub-button>`: null}     
                    <button class="settings" @click=${() => { 
                        this.showSettingsLinksDropdown = !this.showSettingsLinksDropdown;
                        this.showUserAccount = false;
                    }}>
                            <mc-icon width="24px" height="24px" icon="dot-grid"></mc-icon>
                    </button>
                    <button class="user" @click=${() => {
                            this.showUserAccount = !this.showUserAccount;
                            this.showApplicationLinksDropdown = false;
                    }}>
                        <mc-icon icon="user-circle"></mc-icon>
                    </button>
                    ${this.showSettingsLinksDropdown ? this._renderSettingsMenu() : html``}
                    ${this.showUserAccount ? this._renderUserAccount() : html``}     
                    
                    ${ this.showForecastInfo ? html`
                    <voyage-tooltip position-priority='["bottom"]' .for=${this._forecastInfoDiv}>${this._forecastVersionTooltipText()}</voyage-tooltip>
                    `: html`` }
                    ${this.showReleaseNotes ? html`
                        <span class="release-notes">
                            <div class="release-notes-close" @click=${() => this.showReleaseNotes = !this.showReleaseNotes}>${SvgIcons.lightTimes}</div>
                             <object class="release-notes-object" type="text/html" data=  "release-notes-cloud.html" ></object>
                        </span>
                    `: ''}
                </div>
            </div>

                <!-- Polar Route Selection -->
            ${this.showPolarTopBar ? html`
                <polar-route-selection @close-polar-route-selection=${this._handlePolarSelectionClose} .polarRouteCapturedPosition=${this.polarRouteCapturedPosition} .hasParametricRisk=${this.hasParametricRisk} .hasActivePlan=${this.hasActivePlan}></polar-route-selection>
                `: html`` }           
                
                ${this._isDownloading ? html`<map-download-popup progress=${this._downloadProgress} @cancel-map-download=${this._handleMapDownload}></map-download-popup>` : null}
        </div>`;
    }

    firstUpdated() {
        this._forecastInfoDiv = this.shadowRoot!.querySelector(".forecast");
        WeatherModel!.addEventListener('weather-updated', this._updateWeatherForecastAlert);
        VesselPositionModel?.addEventListener('position-updated', this._updateLastPosition);
        VesselMigrationModel?.addEventListener(MigrationChangeEvents.StateChanged, this._setMigrationState);

        this._updateWeatherForecastAlert();
        this._updateLastPosition();
        if(this.appName !== "Fleet Voyage") {
            this._setMigrationState();
        }
    }

    private _handleOnline = () => {
        this.isOnline = true;
        this.dispatchEvent(new CustomEvent('network-change', {
        detail: { online: true },
        bubbles: true,
        composed: true
        }));

    };

    private _handleOffline = () => {
        this.isOnline = false;
        this.dispatchEvent(new CustomEvent('network-change', {
        detail: { online: false },
        bubbles: true,
        composed: true
        }));
    };

    private _handleBacktoFastNetwork = (event: { data: { detail: { val: string; }; }; }) => {
        if(event.data.detail.val === 'yes') {
            this.isOnline = true;
            this.dispatchEvent(new CustomEvent('network-change', {
            detail: { online: true },
            bubbles: true,
            composed: true
        }));
        } else {
            this.isOnline = false;
            this.dispatchEvent(new CustomEvent('network-change', {
            detail: { online: false },
            bubbles: true,
            composed: true
            }));
        }
    }

    connectedCallback() {
        super.connectedCallback();
       
        if ("connection" in navigator) {
        (navigator as any).connection.addEventListener("change", () => {
            console.log("Network changed: capture from topbar comp: ", (navigator as any).connection);
            if(slowNetworkDetected()) {
                VesselAlertsModel!.addAlert(isVesselOnCloud ? VoyageImoModel?.imo : (<any>window)["appenv"].vesselIMONumber, {
                    message: "",
                    id: UUID(),
                    type: AlertType.slowNetworkDetected,
                });
            } else if( (navigator as any).connection?.downlink <= 0 ) {
                // offline scenario
                VesselAlertsModel!.clearAlerts(isVesselOnCloud ? VoyageImoModel?.imo : (<any>window)["appenv"].vesselIMONumber);
                window.addEventListener('offline', this._handleOffline);
                localStorage.setItem('isSlowNetworkOfflineMode', 'No');
            } else {
                // fast network scenario
                VesselAlertsModel!.clearAlerts(isVesselOnCloud ? VoyageImoModel?.imo : (<any>window)["appenv"].vesselIMONumber);
                window.addEventListener('online', this._handleOnline);
                localStorage.setItem('isSlowNetworkOfflineMode', 'No');
            }
        });
        }

        window.addEventListener('slowNetworkOffline', () => {
           this._handleOffline();
        });

        window.addEventListener('slowNetworkOnline', () => {
           this._handleOnline();
        });
        window.addEventListener('backToFastNetwork', (event: Event) => {
           const customEvent = event as CustomEvent;
           this._handleBacktoFastNetwork({ data: { detail: { val: customEvent.detail.val } } });
        });
    }

    disconnectedCallback() {
        WeatherModel!.removeEventListener('weather-updated', this._updateWeatherForecastAlert);
        VesselPositionModel?.removeEventListener('position-updated', this._updateLastPosition);
        VesselMigrationModel?.removeEventListener(MigrationChangeEvents.StateChanged, this._setMigrationState);
        window.removeEventListener('online', this._handleOnline);
        window.removeEventListener('offline', this._handleOffline);
    }

    @property({ type: Object, attribute: false }) private _forecastInfoDiv: HTMLElement|null = null;
    @property({ type: String, attribute: false }) private _forecastStatus: string = ForecastStatusColors.Red;
    @property({ type: Boolean, attribute: false }) private _showMigrationPanel: boolean = false;
    @property({ type: Boolean, attribute: false }) private _migrationState: MigrationState|null = null;

    private _wakeLock: WakeLockSentinel | null = null;

    private _setMigrationState() {
        this._migrationState = VesselMigrationModel!.migrationState;
    }

    private _migrationElement() {
        if (this._migrationState === MigrationState.Windows) {
            return this._readyToMigrateElement();
        }

        if (this._migrationState === MigrationState.MigrationFailed) {
            return this._failedMigrateElement();
        }

        return nothing;
    }
    
    private _readyToMigrateElement() {
        return html`
            <div class="migration-container">
                <div>
                    Please accept to migrate to the new platform, it will not take longer than 15 minutes.
                </div>
                <div class="migration-panel-buttons">
                    <mc-button
                        label="Do it later"
                        variant="outlined"
                        @click=${() => {this._showMigrationPanel = false}}
                    >
                    </mc-button>
                    <mc-button
                        label="Accept"
                        @click=${() => VesselMigrationModel!.startMigration()}
                    >
                    </mc-button>
                </div>
            </div>
        `
    }

    private _failedMigrateElement() {
        return html`
            <div class="migration-container">
                <div>
                    <div class="failed-message">
                        <span>${SvgIcons.lightExclamationCircle}</span>
                        <span class="failed-text">An error has occured.</span>
                    </div>
                    <div>
                        Support will solve the issue and you will be contacted as soon as possible. Thank you for your patience.
                    </div>
                </div>
            </div>
        `
    }

    private _onMigrateClicked() {
        this._showMigrationPanel = !this._showMigrationPanel;
    }

    private async _handleMapDownload() {
        
        if (this._isDownloading) {
            this._cloudMapLayer.cancelDownload();
            return;
        }
        
        // progress callback for percentage feedback
        this._cloudMapLayer.setProgressCallback((progress) => {
            this._downloadProgress = progress.percentage;
            this.requestUpdate();
        });
        
        this._cloudMapLayer.setStateCallback((state) => {
            this._isDownloading = state === 'pending';
            this.requestUpdate();
        });
        
        try {
            if (encTileServer) {
                await this._cloudMapLayer.downloadEncTiles(); // download enc map
            } else  {
                await this._cloudMapLayer.downloadWorldTiles(4); // download worldmap - Open street map - zoom level 4
            }
        } catch (error) {
            console.error('Error downloading maps:', error);
        }   
    }

    private _renderUserAccount() {
        return html` <div class="user-account-dropdown">
            <div class="user-account-info">
                <span>${sessionStorage.getItem('username')}</span>
                <mc-button
                    appearance="neutral"
                    fit="small"
                    @click=${() => AuthService.logout()}
                >
                    <mc-icon icon="arrow-from-left"></mc-icon>
                    Logout
                </mc-button>
            </div>
        </div>`
    }

    private _renderSettingsMenu() {
        return html`
        <div class="settings-links-dropdown">
            <div class="settings-imo">
                <span>IMO: ${VoyageImoModel?.imo || "N/A"}</span>
                 ${(isOnline()) && isVesselOnCloud && AuthService.isLoggedIn && ( sessionStorage.getItem('isVesselUser') ? sessionStorage.getItem('isVesselUser') === 'No' : true) ? html`
                <mc-button 
                 appearance="neutral"
                 fit="small"
                        @click=${() => {
                        VoyageImoModel!.dispatchEvent(new Event(VoyageImoEventNames.showImoPopup));
                        this.showSettingsLinksDropdown = !this.showSettingsLinksDropdown;
                        }}>
                  <mc-icon icon="pencil" style="margin-right: 5px"></mc-icon> Change
                </mc-button> ` : null}
            </div>
            <nested-accordion .items="${this._getSettingsMenuData()}"></nested-accordion>
            ${isVesselOnCloud && offlineMapDownload ? html`<div>
                <button class="settingsEntry"
                        .disabled=${(this._cloudMapLayer?.downloadState === DownloadState.DONE) || !isOnline()}
                        @click=${()=>this._handleMapDownload()}>
                    <mc-icon icon="tray-arrow-down"></mc-icon> <span>Download Offline Map</span>
                    ${(this._cloudMapLayer?.downloadState === DownloadState.DONE) ? html`<mc-tag appearance="success" icon="check-circle" fit="small">Done</mc-tag>` : null}
                </button>
            </div>`: null}
            <div>
                <button class="settingsEntry"
                    @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowPolarRouteSelection));
                        this.showSettingsLinksDropdown = false; }}>
                    ${SvgIcons.polarChart} Polar Chart
                </button>
                ${!isVesselOnCloud ? html `
                <button class="settingsEntry"
                        @click=${() => {/*To be added */ }}>
                    <mc-icon icon="file-magnifying-glass"></mc-icon> WNI Reports
                </button>` : null}
                <button class="settingsEntry"
                            @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowWeatherLimits));
                                            this.showSettingsLinksDropdown = false; }}>
                        <mc-icon icon="sun"></mc-icon> Weather Limits
                </button>
                <button class="settingsEntry"
                            @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowVesselCharacteristics));
                                            this.showSettingsLinksDropdown = false; }}>
                        <mc-icon icon="grid"></mc-icon> Vessel Characteristics
                </button>
                ${isOnline() ? html`<button class="settingsEntry"
                            @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowVesselPosition));
                                            this.showSettingsLinksDropdown = false; }}>
                        <mc-icon icon="radar"></mc-icon> Vessel Position
                </button>`: null}
                ${this.TrinityOn ? html`
                <button class="settingsEntry" id="themeButton"
                            @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowAudioAlert));
                                            this.showSettingsLinksDropdown = false; }}>
                            ${SvgIcons.play} Test Audio Alert
                </button>`: nothing}
            </div>
            <div>
                <button class="settingsEntry"
                        @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowAlarmLogs));
                                        this.showSettingsLinksDropdown = false; }}>
                        <mc-icon icon="file-other"></mc-icon> Log
                </button>
                <button class="settingsEntry"
                        @click=${() => { this.showReleaseNotes = true;
                                     this.showSettingsLinksDropdown = false; }}>
                    <mc-icon icon="file-copy"></mc-icon> Release Notes
                </button>
            </div>
            <div>
                <button class="settingsEntry"
                        @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowHelpCenter));
                                        this.showSettingsLinksDropdown = false; }}>
                        <mc-icon icon="headset"></mc-icon> Help Center
                </button>
            </div>
            <div>
                ${!isVesselOnCloud ? html`<a class="settingsEntry" target="_blank" href=${this.performanceLink}>
                    <mc-icon icon="tachometer"></mc-icon> Performance application
                    <mc-icon icon="square-arrow-up-right"></mc-icon>
                </a>` : null}

                ${!this.includeVesselSettings ? html`
                    <button class="settingsEntry" id="themeButton"
                            @click=${() => { this._toggleDemoMode() }}>
                        ${SvgIcons.desktop} ${this.demoMode ? 'Stop' : 'Start'} Demo Mode
                    </button>`
                : null}
            </div>         
        </div>`
    }

    private _updateWeatherForecastAlert() {
        this.forecastInfo = WeatherModel!.latestForecastInfo;
        if (this.showForecastInfo) {
            this._updateForecastStatus();
            if (this._forecastStatus === ForecastStatusColors.Red) {
                VesselAlertsModel!.addAlert((<any>window)["appenv"].vesselIMONumber, {
                    message: "Current Weather forecast is outdated.",
                    id: AlertType.OutdatedWeather
                });
            } else {
                VesselAlertsModel!.removeAlert((<any>window)["appenv"].vesselIMONumber, AlertType.OutdatedWeather);
            }
        }
    }

    private _updateLastPosition() {
        const positionObj = VesselPositionModel!.position;
        const coords = positionObj
         && positionObj.longitude
         && positionObj.latitude
         && CoordinatesUtils.decimalToDegreesAndMinutes([positionObj.longitude, positionObj.latitude ]);
         if (coords && positionObj?.timestamp) {
             this._positionInfo = {
                 lat: coords.lat,
                 lon: coords.lon,
                 timestamp: prettyTimelapsed(positionObj.timestamp),
                 source: positionObj.source
             }
         }
    }

    private _getForecastVersionText() {
        if (!this.forecastInfo) {
            return "No forecast available!";
        } else {
            const forecastDate = new Date(this.forecastInfo.timestamp);
            if (isNaN(forecastDate.getTime())) {
                return "No forecast available!";
            }
            const day = forecastDate.getUTCDate().toString().padStart(2,'0');
            const month = forecastDate.getUTCMonth() + 1 < 10 ? `0${forecastDate.getUTCMonth() + 1}` : forecastDate.getUTCMonth() + 1;
            const hours = forecastDate.getUTCHours().toString().padStart(2,'0');
            const minutes = forecastDate.getUTCMinutes().toString().padStart(2,'0');

            const ageInHours = (Date.now() - new Date(this.forecastInfo.timestamp).getTime())/(60*60*1000);

            return `+${Math.floor(ageInHours)} (UTC ${hours}:${minutes} - ${day}/${month} )`;
        }
    }

    private _forecastVersionTooltipText() {
        const msg = "Last weather update";

        if (!this.forecastInfo?.hasHighResData) {
            return !isVesselOnCloud ? html`${msg} 
                <br>Resolution is low (2.5 degrees)
                <br>because of poor network connectivity.` : html`${msg}` 
        }

        return msg;
    }

    private _updateForecastStatus() {
        if (!this.forecastInfo)
        {
            this._forecastStatus = ForecastStatusColors.Red;
            return
        }

        const forecastAge = Date.now() - new Date(this.forecastInfo.timestamp).getTime();

        if (forecastAge < 12*60*60*1000)
        {
            this._forecastStatus = ForecastStatusColors.Green;
        }
        else if (forecastAge < 24*60*60*1000)
        {
            this._forecastStatus = ForecastStatusColors.Yellow;
        }
        else
        {
            this._forecastStatus = ForecastStatusColors.Red;
        }
    }

    private async _toggleDemoMode() {
        this.demoMode = !this.demoMode;

        if (this.demoMode) {
            // Go fullscreen
            if (!document.fullscreenElement) {
                document.body.requestFullscreen().catch(err => { console.log(`Error attempting to go full-screen ${err.message}`)});
            }

            // Attempt to do Screen Wake Lock
            if ('wakeLock' in navigator) {
                try {
                    this._wakeLock = await navigator.wakeLock.request('screen');
                    this._wakeLock.addEventListener('release', () => {
                        console.log("Released Wake Lock");
                        this._wakeLock = null;
                    });

                    console.log("Obtained Wake Lock");
                } catch (err) {
                    console.error(`${(<Error>err).name}, ${(<Error>err).message}`);
                }
            }

            UiStateModel!.setValue("demo", "on");
        } else {
            // Disable fullscreen
            if (document.fullscreenElement) {
                document.exitFullscreen();
            }

            // Release Screen Wake Lock
            if (this._wakeLock) {
                this._wakeLock.release();
            }

            UiStateModel!.setValue("demo");
        }

    }

    private _handlePolarSelectionClose() {
        // Emit an event to inform the main-app
        this.dispatchEvent(new Event(VoyageTopbarEventNames.ClosePolarRouteSelection));
        this.showPolarTopBar = false;// Reset online status to true when closing polar route selection
    }

    private _getSettingsMenuData(): AccordionItemData[] {
        const subMenu = [
              {
                id: 'change-theme',
                title: 'Change Theme',
                icon: 'stamp',
                children: [
                  {
                    id: 'day',
                    title: 'Day',
                    icon: 'light-bulb',
                    onClick: () => {
                      // Apply the default theme from VoyageStyle
                      const selectedTheme = StyleName.default;
                      VoyageStyle.applyGlobalStyles(selectedTheme);
                      // Close the settings dropdown
                      this.showSettingsLinksDropdown = false;
                      console.log('Setting theme to Day');
                    }
                  },
                  {
                    id: 'dusk',
                    title: 'Dusk',
                    icon: 'snowflake',
                    onClick: () => {
                      // Apply the dusk theme from VoyageStyle
                      const selectedTheme = StyleName.dusk;
                      VoyageStyle.applyGlobalStyles(selectedTheme);
                      // Close the settings dropdown
                      this.showSettingsLinksDropdown = false;
                      console.log('Setting theme to Dusk');
                    }
                  },
                  {
                    id: 'night',
                    title: 'Night',
                    icon: 'moon',
                    onClick: () => {
                      // Apply the night theme from VoyageStyle
                      const selectedTheme = StyleName.night;
                      VoyageStyle.applyGlobalStyles(selectedTheme);
                      // Close the settings dropdown
                      this.showSettingsLinksDropdown = false;
                      console.log('Setting theme to Night');
                    }
                  }
                ]
              },
              {
                id: 'delete-data',
                title: 'Clear Site Data',
                icon: 'bucket-mop',
                onClick: clearSiteData,
                tooltip: 'This will clear all site data. Use only when you have a stable connection, and proceed with caution.'
            }];

         const subMenuList: AccordionItemData[] =  (!isOnline()) ? 
         subMenu.filter(item => item.id !== 'delete-data') : subMenu;    

        return [
          {
            id: 'settings',
            title: 'Settings',
            icon: 'cog',
            children: subMenuList,
          },
        ];
      }
}